<template>
  <div class="account-list-container">
    <el-row>
      <div class="tfam-table-search">
        <span class="ti-search"></span>
        <input class="form-control" aria-describedby="addon-right addon-left" placeholder="搜尋">
      </div>
    </el-row>
    <el-row>
      <el-table
        v-loading="loading"
        :data="accountList"
        :show-header="false"
        :row-style="rowStyle"
        :cell-style="cellStyle"
        empty-text="無資料"
        style="width: 100%;">
        <el-table-column
          type="index"
          width="80">
        </el-table-column>
        <el-table-column
          prop="name"
          label="名稱"
          width="180">
          <template slot-scope="scope">
            <span class="account-name" @click="goAccount(scope.row['id'])">{{ scope.row.name }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="role"
          label="權限"
          width="130">
          <template slot-scope="scope">
            <span>{{ scope.row.role | roleFilter }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="email"
          label="Email">
        </el-table-column>
      </el-table>
    </el-row>
    <div class="create-new" @click="goAccount(0)">
      <span class="tfam-new"></span>
    </div>
  </div>
</template>

<script>
  import { fetchAccountList } from "../../api/account";

  export default {
    name: "AccountList",
    data() {
      return {
        accountList: [],
        loading: false
      }
    },
    computed: {
      rowStyle: function () {
        return {
          height: '80px',
          cursor: 'default'
        }
      }
    },
    filters: {
      roleFilter: function (role) {
        if (role === 'Admin') {
          return '管理員'
        } else if (role === 'VolunteerA') {
          return '北美館志工 A 組'
        } else if (role === 'VolunteerA') {
          return '北美館志工 B 組'
        }
      }
    },
    mounted() {
      this.getAccountList()
    },
    methods: {
      cellStyle(row, column, rowIndex, columnIndex) {
        console.log(row.column.label);
        if (row.column.label === 'Email') {
          return 'text-align:right'
        } else {
          return ''
        }
      },
      getAccountList() {
        const filter = {
          where: {
            id: {
              neq: this.$store.getters.user.id
            }
          }
        };
        this.loading = true;
        fetchAccountList(filter).then(response => {
          this.loading = false;
          this.accountList = response.data;
        }).catch(err => {
          this.loading = false;
        })
      },
      goAccount(id) {
        this.$router.push({
          path: '/staffs/' + id
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .account-name {
    cursor: pointer;
  }
</style>
